import React from 'react';
import TagManager from 'react-gtm-module';
import { saveUserQuizAnswers } from '../../../api/api';
import { useFunnel } from '../FunnelContext';
import LandingDisclaimer from './LandingDisclaimer';
import Header from '../../../components/Header';
import Footer from '../../../components/Footer';

const HeroSectionNew = () => {
  const { goNext, handleAnswer, funnelName, funnelVersion } = useFunnel();

  const handleClick = (goal) => {
    TagManager.dataLayer({
      dataLayer: {
        event: 'dl_select_goal',
        goal,
      },
    });
    localStorage.setItem('initialGoal', goal);

    const userId = localStorage.getItem('userId');
    if (userId) {
      saveUserQuizAnswers(userId, "What's your goal?", [goal], funnelName, funnelVersion);
    }

    goNext();
  };

  return (
    <>
      <Header />
      <div className="App__content">
        <div className="text-center max-w-[600px] mx-auto px-4 py-8">
          <h2 className="text-[1.75rem] font-bold text-brand-charcoal mb-2 leading-tight">
            The easiest way to grow your sales with AI
          </h2>
          <p className="text-base text-[#666] mb-4">Get your AI growth plan</p>
          <div className="mb-6">
            <img
              src="../assets/images/ad1/lp-cover2.webp"
              alt="Sales growth transformation"
              className="w-full max-w-[420px] mx-auto rounded-xl"
            />
          </div>
          <p className="text-base font-semibold text-brand-charcoal mb-4">What's your goal?</p>
          <div className="flex flex-col gap-3 max-w-[420px] mx-auto mb-6">
            <button
              className="w-full py-4 px-6 text-base font-semibold rounded-xl border-2 border-brand-green bg-brand-green text-white cursor-pointer transition-all hover:bg-brand-green-dark"
              onClick={() => handleClick('Get first sales')}
            >
              Get first sales
            </button>
            <button
              className="w-full py-4 px-6 text-base font-semibold rounded-xl border-2 border-brand-green bg-white text-brand-green cursor-pointer transition-all hover:bg-brand-green-pale"
              onClick={() => handleClick('Drive more sales')}
            >
              Drive more sales
            </button>
          </div>
          <div className="text-center">
            <p className="text-sm text-[#888] mb-3">
              Trusted by <strong>30,000+</strong> businesses on
            </p>
            <div className="flex justify-center gap-4 flex-wrap">
              <div className="flex flex-col items-center">
                <img src="../assets/images/question-answers/shop-logos/etsy.png" alt="Etsy" className="w-8 h-8 mb-1" />
                <span className="text-xs text-[#888] font-semibold">3k+</span>
              </div>
              <div className="flex flex-col items-center">
                <img src="../assets/images/question-answers/shop-logos/amazon.png" alt="Amazon" className="w-8 h-8 mb-1" />
                <span className="text-xs text-[#888] font-semibold">11k+</span>
              </div>
              <div className="flex flex-col items-center">
                <img src="../assets/images/question-answers/shop-logos/shopify.png" alt="Shopify" className="w-8 h-8 mb-1" />
                <span className="text-xs text-[#888] font-semibold">8k+</span>
              </div>
              <div className="flex flex-col items-center">
                <img src="../assets/images/question-answers/shop-logos/instagram.png" alt="Instagram" className="w-8 h-8 mb-1" />
                <span className="text-xs text-[#888] font-semibold">8k+</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <LandingDisclaimer />
      <Footer />
    </>
  );
};

export default HeroSectionNew;
